// @flow strict

import type {
  CredentialsConfig,
  NewCredential,
} from 'src/types/data-integration';
// $FlowFixMe[nonstrict-import]
import type {Dispatch, ThunkAction} from 'src/reducers';
// $FlowFixMe[nonstrict-import]
import * as reduxApi from 'src/utils/redux-api';
// $FlowFixMe[nonstrict-import]
import {thunkify as flow} from 'src/utils/thunks';
// $FlowFixMe[untyped-import]
import {key, fetching} from 'src/utils/redux';


export const GET_CREDENTIALS_META = 'credentials-meta/receive';
export const GET_CREDENTIALS = 'credentials/receive';

type ReceiveCredentialsMetaData = {
  type: typeof GET_CREDENTIALS_META,
  payload: CredentialsConfig,
};

type ReceiveCredentials = {
  type: typeof GET_CREDENTIALS,
  payload: CredentialsConfig,
};

export type CredentialsActions =
  | ReceiveCredentialsMetaData
  | ReceiveCredentials;

export const receiveCredentialsMeta = (
  payload: CredentialsConfig,
): ReceiveCredentialsMetaData => ({
  type: GET_CREDENTIALS_META,
  payload,
});
export const receiveCredentials = (
  payload: CredentialsConfig,
): ReceiveCredentials => ({
  type: GET_CREDENTIALS,
  payload,
});

export const getCredentialsMeta: () => ThunkAction<void> = flow(
  key(() => 'credentials_meta'),
  fetching(),
)(() => async (dispatch: Dispatch) => {
  try {
    const res = await dispatch(reduxApi.get(`credentials/meta`));
    dispatch(receiveCredentialsMeta(res));
    return res;
  } catch (err) {
    throw err;
  }
});

export const getCredentials: () => ThunkAction<void> = flow(
  key(() => 'credentials'),
  fetching(),
)(() => async (dispatch: Dispatch) => {
  try {
    const res = await dispatch(reduxApi.get(`credentials`));
    dispatch(receiveCredentials(res));
    return res;
  } catch (err) {
    throw err;
  }
});

export const getActivityLog: (
  page: number,
  page_size: number,
) => ThunkAction<void> = flow(
  key(() => 'activityLog'),
  fetching(),
)((page: number, page_size: number) => async (dispatch: Dispatch) => {
  try {
    const res = await dispatch(
      reduxApi.get(`credentials/audit-log?page=${page}&page_size=${page_size}`),
    );
    return res;
  } catch (err) {
    throw err;
  }
});

export const updateCredentials: (
  credentialData: NewCredential,
) => ThunkAction<void> = flow(
  key(() => 'credentials_update'),
  fetching(),
)((credentialData) => async (dispatch: Dispatch) => {
  try {
    const res = await dispatch(reduxApi.post(`credentials`, credentialData));
    return res;
  } catch (err) {
    throw err;
  }
});

export const validCredentials: (
  credentialData: NewCredential,
) => ThunkAction<void> = flow(
  key(() => 'credentials_validate'),
  fetching(),
)((credentialData) => async (dispatch: Dispatch) => {
  try {
    const res = await dispatch(
      reduxApi.post(`credentials/validate`, credentialData),
    );
    return res;
  } catch (err) {
    throw err;
  }
});
